export const loginImageMap = {
    us: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1715568541033/login_banner.jpeg',
    au: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1715568541033/login_banner.jpeg',
};
